(ns frontend.view.grid.surveys-grid.mass-remind.event
  (:require [clojure.string :as string]
            [common.languages :as languages]
            [common.localization :as loc]
            [common.util :as cu]
            [frontend.controller.websocket.event :as ws]
            [frontend.intercom :as intercom]
            [frontend.view.grid.surveys-grid.mass-remind.model :as model]
            [frontend.view.grid.surveys-grid.mass-remind.sub :as sub]
            [frontend.view.modals.confirmation.view :as confirmation-modal]
            [frontend.view.modals.events :as modals]
            [re-frame.core :as rf]))

(rf/reg-event-fx
 ::processes-load-ok
 (fn [{db :db} [_ resp]]
   {:db (model/load-ok db (:body resp))}))

(rf/reg-event-fx
 ::processes-load-failed
 (fn [{db :db} [_ err]]
   (js/console.log "Failed to load processes : " err)))

(rf/reg-event-fx
 ::init
 (fn [{db :db} [_ selected-profile-ids]]
   (intercom/hide)
   {:db       (model/init db)
    ::ws/send {:id         :survey-profile/get-reminder-processes
               :body       {:ids selected-profile-ids}
               :on-success [::processes-load-ok]
               :on-error   [::processes-load-failed]}}))

(rf/reg-event-fx
 ::cancel
 (fn [{db :db} _]
   (intercom/show)
   {:db (model/clean-up db)}))

(rf/reg-event-fx
 ::set-language
 (fn [{db :db} [_ lang]]
   {:db (model/set-lang db lang)}))

(rf/reg-event-fx
 ::set-subject
 (fn [{db :db} [_ lang new-subject]]
   {:db (model/set-subject db lang new-subject)}))

(rf/reg-event-fx
 ::set-body-1
 (fn [{db :db} [_ lang new-body]]
   {:db (model/set-body-1 db lang new-body)}))


(rf/reg-event-fx
 ::set-body-2
 (fn [{db :db} [_ lang new-body]]
   {:db (model/set-body-2 db lang new-body)}))

(rf/reg-event-fx
 ::send-reminders-ok
 (fn [{db :db} [_ resp]]
   {:db (model/send-ok db (:body resp))}))

(rf/reg-event-fx
 ::send-reminders-failed
 (fn [{db :db} [_ err]]
   {:db (model/send-failed db err)}))

(rf/reg-event-fx
 ::send-reminders!
 (fn [{db :db} _]
   (let [processes (get-in db model/processes-full-path)
         subjects (get-in db model/subject-full-path)
         bodies-1 (get-in db model/body-1-full-path)
         bodies-2 (get-in db model/body-2-full-path)]
     {:db       (model/start-processing db)
      ::ws/send {:id         :survey-profile/send-reminders
                 :body       {:subjects    subjects
                              :bodies-1    bodies-1
                              :bodies-2    bodies-2
                              :process-ids (map :db/id processes)}
                 :on-success [::send-reminders-ok]
                 :on-error   [::send-reminders-failed]}})))

(rf/reg-event-fx
 ::send-all!
 (fn [{db :db} _]
   (let [processes (get-in db model/processes-full-path)
         languages (sub/resolve-languages processes)
         missing-languages (->> languages
                                (filter (fn [lang]
                                          (cu/blank-value? (get-in db (model/subject-lang-path lang)))))
                                (seq))
         single-missing? (= 1 (count missing-languages))
         lang-names-list (loc/tr :and [(->> missing-languages
                                            (butlast)
                                            (map languages/get-label)
                                            (string/join ", "))
                                       (languages/get-label (last missing-languages))])]
     (js/console.log "Missing : " missing-languages
                     "\n" lang-names-list)
     (if missing-languages
       (do (modals/open-modal!
            confirmation-modal/modal-key
            {:body           [:p
                              (if single-missing?
                                (loc/tr :missing-reminder-email-language-confirm [(languages/get-label (first missing-languages))])
                                (loc/tr :missing-reminder-email-languages-confirm [lang-names-list]))]
             :skip-checkbox? true
             :body-class     "text"
             :confirm-text   (if single-missing?
                               (loc/tr :send-reminder-button)
                               (loc/tr :send-reminders-button))
             :on-confirm     (fn [_]
                               (rf/dispatch [::send-reminders!]))})
           nil)
       {:fx [[:dispatch [::send-reminders!]]]}))))
